import { Alert, Button, Card, Empty } from 'antd';
import { FC } from 'react';
import { GearFill } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';

import { AppRoutes } from '@/common/interfaces';

interface Props {
  domainId: string;
  disableButtons: boolean;
  errorMessage?: string | null;
}

export const DomainNoConfigView: FC<Props> = ({ domainId, disableButtons, errorMessage }) => {
  return (
    <Card
      title="Розгортання"
      extra={
        <Link to={ AppRoutes.DomainsByIdConfigAttach.replace(':domainId', domainId) }>
          <Button disabled={ disableButtons } type="dashed">Налаштувати</Button>
        </Link>
      }
    >
      {
        errorMessage && (
          <Alert
            message={ errorMessage }
            type="error"
            showIcon
          />
        )
      }
      &nbsp;
      <Empty image={ <GearFill style={{ opacity: 0.15 }} size={ 60 }/> } description="Конфігурація відсутня"/>
    </Card>
  );
};
